/**
 * Entry point React — mount ứng dụng vào DOM.
 *
 * Provider hierarchy:
 * - AuthProvider: session user, login/logout.
 * - FavoriteProvider: state yêu thích toàn cục.
 * - App: router và routes.
 *
 * Cấu hình scroll: tắt scroll restoration mặc định của browser,
 * cuộn về đầu trang khi load lần đầu.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'leaflet/dist/leaflet.css';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { FavoriteProvider } from './context/FavoriteContext';
import reportWebVitals from './reportWebVitals';

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

window.scrollTo(0, 0);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <FavoriteProvider>
        <App />
      </FavoriteProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
